<template>
  <div class="app-shell home-page info-page">
    <div class="app-shell__main">
      <AppHeader />

      <main class="info-main">
        <section class="info-hero info-hero--records">
          <div class="info-badge">Currency Record</div>
          <h1 class="info-title">积分明细</h1>
          <p class="info-description">查看最近一个月内的积分增加与消费记录，方便确认使用情况和充值到账状态。</p>
          <div class="info-summary">
            <article class="info-summary-card">
              <strong>{{ records.length }}</strong>
              <span>当前已加载</span>
            </article>
            <article class="info-summary-card">
              <strong>{{ total }}</strong>
              <span>累计记录</span>
            </article>
            <article class="info-summary-card">
              <strong>{{ hasMore ? '可继续加载' : '已全部展示' }}</strong>
              <span>展示范围</span>
            </article>
          </div>
        </section>

        <section class="info-panel">
          <div class="info-section-head">
            <h2 class="section-title">最近一个月积分记录</h2>
            <p>仅展示最近一个月内的积分增加与消费明细。</p>
          </div>

          <div v-if="records.length" class="record-list">
            <article v-for="item in records" :key="item.id || `${item.typeText}-${item.createTime}`" class="record-item">
              <div class="record-main">
                <div class="record-type">{{ item.typeText || '积分变动' }}</div>
                <div class="record-time">{{ item.createTimeText }}</div>
              </div>
              <div class="record-side">
                <div class="record-value" :class="item.action === 1 ? 'is-consume' : 'is-increase'">
                  {{ item.displayValue || '--' }}
                </div>
                <div class="record-action">{{ item.actionText || '--' }}</div>
              </div>
            </article>
          </div>

          <div v-else class="info-empty">
            <div class="info-empty__title">暂无积分明细</div>
            <p>最近一个月内没有积分变动记录。</p>
          </div>

          <div v-if="records.length" class="record-footer">
            <button v-if="hasMore" type="button" class="secondary-button" :disabled="loading" @click="loadRecords(false)">
              {{ loading ? '加载中...' : '加载更多' }}
            </button>
            <p v-else>已加载全部记录</p>
          </div>
        </section>
      </main>
    </div>

    <AppFooter />
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader.vue'
import AppFooter from '@/components/AppFooter.vue'
import { getCurrencyRecordPage } from '@/api/currency'
import { formatTimestamp } from '@/utils/date'
import { showToast } from 'vant'

export default {
  name: 'CurrencyRecord',
  components: {
    AppHeader,
    AppFooter
  },
  data() {
    return {
      records: [],
      page: 1,
      pageSize: 10,
      total: 0,
      hasMore: true,
      loading: false
    }
  },
  mounted() {
    this.loadRecords(true)
  },
  methods: {
    async loadRecords(refresh = false) {
      const nextPage = refresh ? 1 : this.page
      if (this.loading) return

      this.loading = true
      try {
        const res = await getCurrencyRecordPage({
          page: nextPage,
          pageSize: this.pageSize
        })
        const list = (res?.list || []).map(item => ({
          ...item,
          createTimeText: item.createTime ? formatTimestamp(new Date(item.createTime)) : ''
        }))

        this.records = refresh ? list : this.records.concat(list)
        this.page = nextPage + 1
        this.total = res?.total || 0
        this.hasMore = !!res?.hasMore
      } catch (error) {
        console.error(error)
        showToast(error?.message || '积分记录加载失败')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
